import { render, staticRenderFns } from "./CalendarLinksCard.vue?vue&type=template&id=1c79ba24&scoped=true"
import script from "./CalendarLinksCard.vue?vue&type=script&lang=js"
export * from "./CalendarLinksCard.vue?vue&type=script&lang=js"
import style0 from "./CalendarLinksCard.vue?vue&type=style&index=0&id=1c79ba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79ba24",
  null
  
)

export default component.exports